module.exports = __webpack_public_path__ + "img/Journalism.71c20c4a.jpg";